// extracted by mini-css-extract-plugin
export default {"table_wrapper":"THR_table_wrapper__FxJ+s","popup":"THR_popup__mFRd4","popUpChild":"THR_popUpChild__6G7Mi"};